import { useTranslation } from "react-i18next"
import { PlanTable } from "@/components/plans/plan-table"
import { PageHeader } from "@/components/shared/page-header"

export default function PlansPage() {
  const { t } = useTranslation()

  return (
    <div className="space-y-6">
      <PageHeader title={t("plans.title")} description={t("plans.description")} />
      <PlanTable />
    </div>
  )
}
